import React from 'react';
import ReactPaginate from 'react-paginate';
import PropTypes from 'prop-types';
import { FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';

import styles from './LowerPager.scss';

const LowerPager = ({
  pageCount,
  initialPage,
  forcePage,
  perPage,
  perPages,
  onPageChange,
  onPerPageChange,
  totalCount = 0,
  displayFrom,
  displayTo
}) => (
  <div className={styles.wrap}>
    <select className={styles.selectPagingParSize} onChange={onPerPageChange} value={perPage}>
      {perPages.map(page => (
        <option key={page.value} value={page.value}>
          {page.label}
        </option>
      ))}
    </select>
    <div className={styles.container}>
      <ReactPaginate
        pageCount={pageCount}
        pageRangeDisplayed={3}
        marginPagesDisplayed={1}
        initialPage={initialPage}
        forcePage={forcePage}
        onPageChange={onPageChange}
        containerClassName="pagination"
        activeClassName="active"
        disableInitialCallback
        previousLabel={<FaAngleDoubleLeft style={{ verticalAlign: 'baseline' }} />}
        nextLabel={<FaAngleDoubleRight style={{ verticalAlign: 'baseline' }} />}
      />
      <div className={styles.displayPageEntries}>
        <span>
          Display {displayFrom}-{displayTo} out of {totalCount}
        </span>
      </div>
    </div>
  </div>
);
LowerPager.propTypes = {
  pageCount: PropTypes.number.isRequired,
  initialPage: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  perPages: PropTypes.array.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onPerPageChange: PropTypes.func.isRequired
};
export default LowerPager;
